import { Box, Grid, GridItem } from '@everlywell/ui-kit';
import RichTextWrapper from 'components/RichTextWrapper';
import React from 'react';

import BulletPointWithIcon, {
  BulletPointWithIconProps,
} from '../BulletPointWithIcon';

export type ProductPromotionProps = {
  body?: Queries.ContentfulSection001Body | null;
  bulletPoints?: BulletPointWithIconProps[] | null;
};

/**
 * ProductPromotion component is used to display a product promotion section.
 * With a rich text body and bullet points
 * @param {ProductPromotionProps} props ProductPromotionProps object containing body and bulletPoints
 * @param {Queries.contentfulMetadata001DescriptionTextNode} props.body body of the product promotion section
 * @param {BulletPointWithIconProps[]} props.bulletPoints bullet points of the product promotion section
 * @returns {JSX.Element} containing product promotion section
 */
export default function ProductPromotion({
  body,
  bulletPoints,
}: ProductPromotionProps): JSX.Element {
  return (
    <Box
      backgroundColor="tints.lightCream"
      padding={[6, null, 8]}
      borderRadius="xl"
      data-testid="hero-product-promotion"
    >
      {body ? (
        <Box marginBottom={[6, null, 8]}>
          <RichTextWrapper contentfulRichText={body} />
        </Box>
      ) : null}

      {bulletPoints && bulletPoints.length > 0 ? (
        <Grid
          as="ul"
          listStyleType="none"
          columns={[1, 2]}
          alignEdges
          spacing="4"
        >
          {bulletPoints.map((bulletPoint, index) => (
            <GridItem as="li" key={`bullet-point-${index}`}>
              <BulletPointWithIcon
                {...bulletPoint}
                iconBackgroundColor="tints.white"
                hasRoundIconBackground
              />
            </GridItem>
          ))}
        </Grid>
      ) : null}
    </Box>
  );
}
